import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ReferralWithdrawal = React.lazy(() =>
    import('../ReferralWithdrawal')
);
const referralWithdrawalRoutesRegistry = [
    {
        path: PAGE_URL.REFERRAL_WITHDRAWAL_PAGE,
        element: <ReferralWithdrawal />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default referralWithdrawalRoutesRegistry;
